<div>
  <p [class]="classes">
    {{ metrics }}
  </p>
</div>
